// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__3M4QO","error":"Input_error__2UpqL"};